import classNames from "classnames";
import React from "react";
import arrowIcon from "../assets/images/link-arrow.svg";
import { isNullOrWhiteSpace, replaceWithUnicode } from "../shared/string";
import SanityLink from "./SanityLink";

export interface RelatedListItem {
  id: string;
  title: string;
}

export interface RelatedListProps {
  items: RelatedListItem[];
  subtitle?: string;
  title?: string;
}

export const RelatedList = ({ items, subtitle, title }: RelatedListProps) => (
  <aside>
    {!isNullOrWhiteSpace(title) && <h2 className="text-current">{title}</h2>}

    {!isNullOrWhiteSpace(subtitle) && (
      <h3 className="text-brand-primary-dim text-base uppercase font-bold lg:text-xl lg:mt-2">
        {subtitle}
      </h3>
    )}

    <div className="grid grid-cols-[repeat(3,1fr)] overflow-auto border-t border-brand-primary-95">
      {items.map(item => (
        <div
          className={classNames(
            "py-3 border-b border-brand-primary-95 whitespace-wrap",
            // Use nth-child to expand last grid item width
            "last:[&:nth-child(3n-1)]:col-span-2 last:[&:nth-child(3n+1)]:col-span-full"
          )}
          key={item.id}
        >
          <SanityLink
            className={classNames(
              "mr-8 mb-2 group no-underline text-brand-primary-70 border-b border-brand-primary-70 text-lg",
              "focus:outline-none focus:shadow-card-outline"
            )}
            isExternalLink={false}
            reference={{
              _id: item.id
            }}
          >
            <span className="pr-2">{replaceWithUnicode(item.title)}</span>

            <svg className="inline-block mb-[3px] transform-gpu transition-all duration-200 group-hover:translate-x-1 group-hover:transform-gpu w-4 h-4">
              <use xlinkHref={arrowIcon.url} />
            </svg>
          </SanityLink>
        </div>
      ))}
    </div>
  </aside>
);
